var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.775 22.392a19.192 19.192 0 0 1 13.475 0 18.375 18.375 0 0 1 11.638 17.15v16.333a1.837 1.837 0 0 1-2.042 2.042H23.18a1.837 1.837 0 0 1-2.042-2.042V39.542a18.375 18.375 0 0 1 11.637-17.15ZM47.68 45.667a6.125 6.125 0 0 0-6.125-6.125H37.47a2.042 2.042 0 1 1 0-4.083h8.167a2.042 2.042 0 0 0 0-4.084h-4.083a2.042 2.042 0 1 0-4.084 0 6.125 6.125 0 1 0 0 12.25h4.084a2.042 2.042 0 1 1 0 4.084h-8.167a2.042 2.042 0 1 0 0 4.083h4.083a2.042 2.042 0 1 0 4.084 0 6.125 6.125 0 0 0 6.125-6.125Z",
    fill: "#006C52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#006C52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.776 22.392a19.192 19.192 0 0 1 13.474 0l.817-2.858a2.042 2.042 0 0 0-2.041-2.45H34a2.042 2.042 0 0 0-2.041 2.45l.817 2.858ZM41.555 39.542H37.47a2.042 2.042 0 1 1 0-4.083h8.167a2.042 2.042 0 1 0 0-4.084h-4.083a2.042 2.042 0 1 0-4.084 0 6.125 6.125 0 0 0 0 12.25h4.084a2.042 2.042 0 1 1 0 4.084h-8.167a2.042 2.042 0 1 0 0 4.083h4.083a2.042 2.042 0 0 0 4.084 0 6.125 6.125 0 1 0 0-12.25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashFlow);
export default __webpack_public_path__ + "static/media/cash-flow.729fd291.svg";
export { ForwardRef as ReactComponent };